import axios from "axios";
import {
  AuthApi, DonateProvidersApi, FilesApi,
  GenresApi, HomeFlyersApi,
  ReservationsApi,
  ShowEventsApi,
  ShowsApi, TermsAndConditionsApi,
  TicketsApi,
  UserApi,
  UserShowsApi
} from './generated'

import config from '../config/config.json'

axios.defaults.baseURL = config.API_URL
axios.defaults.withCredentials = true
axios.defaults.withXSRFToken = true
axios.defaults.headers['Accept'] = 'application/json'

const api = {
  Auth: new AuthApi(),
  User: new UserApi(),
  Genre: new GenresApi(),
  Shows: new ShowsApi(),
  ShowEvent: new ShowEventsApi(),
  Reservation: new ReservationsApi(),
  Tickets: new TicketsApi(),
  UserShows: new UserShowsApi(),
  Files: new FilesApi(),
  DonationProviders: new DonateProvidersApi(),
  HomeFlyers: new HomeFlyersApi(),
  TermsAndConditions: new TermsAndConditionsApi(),
}

export default api
